<template>
  <div v-if="visible" ref="confirm" class="cp-confirm">
    <div class="box-mask">
      <div class="box-container">
        <div class="close" @click="handleAction('cancel')"></div>
        <div class="box-title">
          <span :data-text="title">{{ title }}</span>
        </div>
        <div class="box-content">{{ text }}</div>
        <div class="box-bottom">
          <div class="bottom-item" @click="handleAction('yes')"></div>
          <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  data() {
    return {
      visible: false,
      title: '',
      text: '',
      promiseStatus: null
    }
  },
  methods: {
    confirm() {
      let _this = this;
      this.visible = true;
      return new Promise(function(resolve, reject) {
        _this.promiseStatus = { resolve, reject };
      });
    },
    handleAction(action) {
      this.$refs.confirm.className += ' fadeOut';
      let t = setTimeout(() => {
        this.visible = false;
        clearTimeout(t);
        if (action === 'yes') {
          this.promiseStatus && this.promiseStatus.resolve('ok');
        } else {
          this.promiseStatus && this.promiseStatus.reject('cancel');
        }
      }, 300);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cp-confirm {
    text-align: center;
    color: #2c3e50;
    height: 100%;
    font-size: .32rem;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index 3
    top 0
    animation fadeIn 0.3s ease-in-out
    &.fadeOut {
      animation fadeOut 0.3s ease-in-out
      animation-fill-mode forwards
    }
    .box-mask{
      z-index: 900;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .box-container{
    // border-radius: 0.15rem;
    background: url('./images/bg.png');
    background-size 100% 100%;
    width: 6.65rem;
    height: 4.15rem;
    position relative
    .close {
      position absolute
      top -0.08rem
      left 5.95rem
      width 0.75rem
      height 0.74rem
      background: url('./images/close.png');
      background-size 100% 100%;
    }
    .box-title {
      text-align: center;
      line-height 1.23rem;
      font-size: 0.4rem;
      margin-bottom 0.13rem
      font-weight 600
      span {
        text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.004);
        position relative
        background-image: linear-gradient(#fade6c, #a46c1c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .box-content{
      height: 1.46rem;
      padding: 0 0.8rem;
      word-break: break-all;
      line-height: 0.42rem;
      font-size 0.24rem
      text-align left
      color #fed045
    }
    .box-bottom{
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 1.59rem
      .bottom-item {
        width: 1.5rem;
        height: 0.63rem;
        background: url('./images/confirm.png');
        background-size 100% 100%;
        &.cancel {
          background-image: url('./images/back.png');
        }
      }
    }
  }
  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
